<script>
export default {
    name: "Stocklevelperstore",

    data() {

        return {
            itemsstocks: [],
            items: [],
            qtyitems: [],
            itemtypes:[],
            filter: {
                date: window.moment().format('YYYY-MM-DD'),
                itemtypeId:0,
                searchFilter:'',

            },
            userName: this.$root.username,
        };
    },

    mounted () {

        this.fetchAll();
        this. getItemTypes();
        
    },

    methods: {

        fetchAll () {

            this.$root.loading = true;
            let url=`Inventory/GetItemsForSearchandItemType`;
            url += `?ItemTypeId=${this.filter.itemtypeId}`;
            url += this.filter.searchFilter ? `&SearchText=${this.filter.searchFilter}` : ``;
              
           this.$accountsHttp.get(url)
                .then(response => { this.itemsstocks = response.data; this.$root.loading = false; })
                .catch(() => { this.$root.loading = false; });
        },
        getItemStockLevel(ItemId,StoreId) {
 
let qtystoreitems=this.itemsstocks.itemsStore.filter(itm => itm.itemID == ItemId && itm.storeID == StoreId);
 qtystoreitems.length
                                        ?
                                       qtystoreitems[0].qty
                                        :
                                        0
 
    },
      getItemTypes() {
            return this.$accountsHttp.get('Shared/ItemTypes').then(response => {
                this.itemtypes = response.data;
            }).catch(() => {});
        },
},
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
                <template v-slot:card-header>
                    <h5 class="text-sm font-medium">Price List Report</h5>
                </template>
                <template v-slot:card-body>
                    <div class="flex w-full">
                        <div class="p-tiny">
                     <label for="grid-store-from" class="label-control">Search :</label> 
                   </div><div class="w-1/4 p-tiny">
                             
                             <input type="text" v-model.trim="filter.searchFilter"
                     
                    id="grid-search" class="input-control input-sm text-xs">   </div>
                       
                        <div class="p-tiny">
                     <label for="grid-store-from" class="label-control">Item Type:</label> 
                   </div> <div class="w-1/4 p-tiny">
                <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from" 
                              v-model.trim="filter.itemtypeId"
                            class="input-control input-sm text-xs">
                            <option :value="0">Select Item Type</option>
                            <option v-for="itemtype in itemtypes" 
                                :key="itemtype.id" :value="itemtype.id">{{ itemtype.type_Name }}</option>
                        </select>
                    </template>
                </tail-select>
               
            </div> <div class="w-1/4 p-tiny pl-2">
                            <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchAll"><i class="fa fa-filter"></i> Filter</button>
                        </div>
                    </div>
                    <div class="w-full overflow-auto">
                        <table class="table table-hover">
                            <thead class="bg-blue-500 text-xs text-white">
                                <tr class="w-full flex">
                                    <th class="p-tiny w-1/6">ItemId</th>
                                    <th class="p-tiny w-1/6">ItemName</th>
                                    <th class="p-tiny w-1/6">Type</th>
                                     <th class="p-tiny flex-1">Minimum Price</th>
                    <th class="p-tiny flex-1">Retail Price</th>
                    <th class="p-tiny flex-1">Company Price</th>
                    <th class="p-tiny flex-1">Cooporate Price</th>
                    <th class="p-tiny flex-1">Maximum Price</th>
                                     </tr>
                            </thead>
                            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                                <tr class="flex w-full" v-for="(item, idx) in itemsstocks" :key="idx">
                                    <td class="p-tiny w-1/6"> {{item.itemID }}</td>
                                    <td class="p-tiny w-1/6">{{ item.itemName}}</td>
                                    <td class="p-tiny w-1/6">&nbsp;&nbsp;{{ item.typeName}}</td>
                                    <td class="p-tiny flex-1">&nbsp;&nbsp;&nbsp; {{ item.minimumPrice | numberFormat}}</td>
                                      <td class="p-tiny flex-1">&nbsp;&nbsp;&nbsp; {{ item.retailPrice | numberFormat}}</td>
                                    <td class="p-tiny flex-1"> &nbsp;&nbsp;&nbsp;  {{  item.tradePrice | numberFormat}}</td>
                                    <td class="p-tiny flex-1">&nbsp;&nbsp;&nbsp; {{ item.specialPrice | numberFormat}}</td>
                                    <td class="p-tiny flex-1">&nbsp;&nbsp;&nbsp; {{ item.maximunPrice | numberFormat}}</td>
                                  
                                    
                                     
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
                <template v-slot:card-footer>
                    <div class="w-full text-right">
                      <router-link :to="{ name: `inventory-management.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                    </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
